<div class="has-validation">
  @if (label() !== "") {
    <div>
      <label
        [class.required]="isRequired()"
        class="form-label"
        for="{{ for() }}"
        >{{ label() | translate }}</label
      >
    </div>
  }
  <ng-content></ng-content>

  @if (hasError()) {
    <div class="invalid-feedback">
      {{ validationLabel() | translate }}
    </div>
  }
</div>
